import { FC } from 'react';
import { useIntl } from 'react-intl';

export const ErrorFeedback: FC = () => {
  const { formatMessage } = useIntl();
  return (
    <small className="form-text text-warning">{formatMessage({ id: 'userPreferencesForm.incoherent.value' })}</small>
  );
};
